export const appConfiguration = {
    firebase: {
        apiKey: "AIzaSyAGHSQW9Z3hehDFsApZXKMlHnID7NCabA0",
        authDomain: "junux-101111.firebaseapp.com",
        databaseURL: "https://junux-101111.firebaseio.com",
        projectId: "junux-101111",
        storageBucket: "junux-101111.appspot.com",
        messagingSenderId: "963578656863"
    }
};